import { render } from "./ChatView.vue?vue&type=template&id=5fd04c52&scoped=true"
import script from "./ChatView.vue?vue&type=script&lang=ts"
export * from "./ChatView.vue?vue&type=script&lang=ts"

import "./ChatView.vue?vue&type=style&index=0&id=5fd04c52&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5fd04c52"

export default script